module.exports = __webpack_public_path__ + "static/media/bmt.1ce77e26.jpg";